import {
  UPDATE_SURVEY_TO_FILL_DATA,
  UPDATE_SURVEY_TO_FILL_QUESTION,
  TOGGLE_LOADING_SURVEY_TO_FILL,
  SURVEY_TO_FILL_ERROR,
  SURVEY_TO_FILL_RESET_ERRORS,
  SURVEY_TO_FILL_RESET_STATE
} from '../actions/dataEntryFillASurveyActions';

const initState = {
  name: 'Data Entry Fill A Survey',
  fillASurvey: {
    loading: true,
    data: null,
    error: null
  }
};

const dataEntryFillASurveyReducer = (state = initState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case UPDATE_SURVEY_TO_FILL_DATA:
      newState.fillASurvey.data = action.payload.value;
      break;

    case UPDATE_SURVEY_TO_FILL_QUESTION:
      const { questionId, newData } = action.payload.value;

      const updatedState = {
        ...state,
        fillASurvey: {
          ...state.fillASurvey,
          data: {
            ...state.fillASurvey.data,
            template: {
              ...state.fillASurvey.data.template,
              questions: state.fillASurvey.data.template.questions.map((question) =>
                question.id === questionId ? { ...question, ...newData } : question
              )
            }
          }
        }
      };

      return updatedState;

    case SURVEY_TO_FILL_RESET_ERRORS:
      const newQuestions = newState.fillASurvey?.data?.template?.questions.map((question) => {
        return { ...question, error: null };
      });

      newState.fillASurvey.data.template.questions = newQuestions;
      break;

    case TOGGLE_LOADING_SURVEY_TO_FILL:
      newState.fillASurvey.loading = action.payload.value;
      break;

    case SURVEY_TO_FILL_ERROR:
      newState.fillASurvey.error = action.payload.value;
      break;

    case SURVEY_TO_FILL_RESET_STATE:
      newState.fillASurvey = {
        data: null,
        loading: false,
        error: null
      };
      break;

    default:
      break;
  }
  return newState;
};

export default dataEntryFillASurveyReducer;
